export default "__VITE_ASSET__BZCg_4w0__"